<common_page_object_non_escape_html>

    <script>
        export default {
            setInnerHTML() {
                this.root.innerHTML = this.props.html
            },
            onMounted() {
                this.setInnerHTML()
            },
            onUpdated() {
                this.setInnerHTML()
            }
        }
    </script>

</common_page_object_non_escape_html>